
import React, { useState,useEffect} from "react";

export default function ExclusivePartnersCarousel() {
   useEffect(() => {
      window.scrollTo(0, 0); 
    }, []);
  const partners = [
    {
      image: "/assets/mcf.png",
      title: "Mastercard Foundation",
      description:
        "The Mastercard Foundation supports education, employment, and entrepreneurship programs across Africa, empowering young people to lead transformative change in their communities.",
    },
   
    {
      image: "/assets/Moe.png",
      title: "Ministry of Education",
      description:
        "The Ministry of Education leads efforts to enhance quality learning and access to education, ensuring an inclusive and equitable education system for all.",
    },
     {
      image: "/assets/Mols.png",
      title: "Ministry of Labor & Skills",
      description:
        "The Ministry of Labor & Skills focuses on building a skilled workforce, promoting employment opportunities, and driving national development through innovation and collaboration.",
    },
    {
      image: "/assets/ENAB.png",
      title: "Ethiopian National Association of the Blind",
      description:
        "ENAB is dedicated to advocating for the rights of visually impaired individuals, promoting accessibility, and empowering its members through education and skill development.",
    },
    {
      image: "/assets/awib.webp",
      title: "Association of Women in Boldness | Female Leadership Program",
      description:
        "AWiB is a vibrant community of women leaders fostering personal growth, professional development, and societal impact through bold leadership and collaboration.",
    },
  ];

  const universities = [
    { image: "/assets/addisababaunilogo.png", name: "Addis Ababa University" },
    { image: "/assets/Adamalogo.png", name: "Adama University" },
    { image: "/assets/AASTUlogo.jpg", name: "AASTU" },
    { image: "/assets/bahirdarunilogo.jpg", name: "Bahir Dar University" },
    { image: "/assets/wkulogo.png", name: "Wolkite University" },
    { image: "/assets/hwulogo.png", name: "Hawassa University" },
    { image: "/assets/2.png", name: "Arbaminch University" },
    { image: "/assets/3.png", name: "Arsi University" },
    { image: "/assets/4.png", name: "Asosa University" },
    { image: "/assets/5.png", name: "Aksum University" },
    { image: "/assets/6.png", name: "Debark University" },
    { image: "/assets/7.png", name: "DebreBirhan University" },
    { image: "/assets/8.png", name: "Debretabor University" },
    { image: "/assets/9.png", name: "Dilla University" },
    { image: "/assets/10.png", name: "Maddawalabu University" },
    { image: "/assets/11.png", name: "Haramaya University" },
    { image: "/assets/12.png", name: "Jigjiga University" },
    { image: "/assets/13.png", name: "Jimma University" },
    { image: "/assets/14.png", name: "Mekdela Amba University" },
    { image: "/assets/15.png", name: "Oda bultum University" },
    { image: "/assets/16.png", name: "Samara University" },
    { image: "/assets/17.png", name: "Salale University" },
    { image: "/assets/18.png", name: "Gondor University" },
    { image: "/assets/19.png", name: "Wachemo University" },
    { image: "/assets/20.png", name: " Adigrat University" },
    { image: "/assets/21.png", name: "Woldia University" },
    { image: "/assets/22.png", name: "Wollega University" },
    { image: "/assets/23.png", name: "Wollo University" },
    { image: "/assets/24.png", name: " Wolaita Sodo University" },
  ];

  const companies = [
    { image: "/assets/NTE.png", name: "National Tobacco Enterprise (Ethiopia) S.C (JTI)" },
    { image: "/assets/soslogo.png", name: "SOS Children's Villages in Ethiopia" },
    { image: "/assets/multichoicelogo.webp", name: "Multi Choice Ethiopia" },
    { image: "/assets/Dashnbanklogo.png", name: "Dashen Bank" },
    { image: "/assets/peopleinneedlogo.png", name: "People In Need" },
    { image: "/assets/unilever.png", name: "Unilever Manufacturing PLC" },
    { image: "/assets/zemenbanklogo.jpg", name: "Zemen Bank" },
    { image: "/assets/HeinekenLogo.png", name: "Heineken" },
    { image: "/assets/Coca-Cola_logo.png", name: "Coca Cola" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showAllUniversities, setShowAllUniversities] = useState(false);

  const handlePrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? partners.length - 1 : prevIndex - 1
    );
    setTimeout(() => setIsAnimating(false), 500);
  };

  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prevIndex) =>
      prevIndex === partners.length - 1 ? 0 : prevIndex + 1
    );
    setTimeout(() => setIsAnimating(false), 500);
  };

  const currentPartner = partners[currentIndex];

  return (
    <div className="bg-gradient-to-b from-white to-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      {/* Section Header */}
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-[#fa5d15] mb-4">
          Our Valued Partners
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Collaborating with leading organizations to create meaningful impact
        </p>
      </div>

      {/* Main Partner Carousel */}
      <div className="relative w-full max-w-6xl mx-auto rounded-xl shadow-lg bg-white overflow-hidden transition-all duration-300 hover:shadow-xl">
        <div
          className={`flex flex-col md:flex-row items-center transition-opacity duration-500 ${
            isAnimating ? "opacity-70" : "opacity-100"
          }`}
        >
          <div className="w-full md:w-1/3 bg-gray-100 p-8 flex justify-center">
            <img
              src={currentPartner.image}
              alt={currentPartner.title}
              className="h-48 w-auto object-contain transition-transform duration-300 hover:scale-105"
            />
          </div>
          <div className="p-8 md:w-2/3">
            <div className="flex items-center mb-4">
              <span className="inline-block w-12 h-1 bg-[#fa5d15] mr-4"></span>
              <h3 className="text-2xl font-bold text-gray-800">
                {currentPartner.title}
              </h3>
            </div>
            <p className="text-gray-600 mb-6">{currentPartner.description}</p>
            <div className="flex space-x-2">
              {partners.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full ${
                    currentIndex === index ? "bg-[#fa5d15]" : "bg-gray-300"
                  }`}
                  aria-label={`Go to partner ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        <button
          onClick={handlePrev}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 border border-gray-200 rounded-full p-3 shadow-md hover:bg-[#fa5d15] hover:text-white transition-all duration-300 hover:scale-110"
          aria-label="Previous partner"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <button
          onClick={handleNext}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 border border-gray-200 rounded-full p-3 shadow-md hover:bg-[#fa5d15] hover:text-white transition-all duration-300 hover:scale-110"
          aria-label="Next partner"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

   
      <div className="w-full max-w-7xl mx-auto mt-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#fa5d15] mb-3">
            Partner Universities
          </h2>
          <div className="w-20 h-1 bg-[#fa5d15] mx-auto mb-4"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We collaborate with leading academic institutions across the region
          </p>
        </div>

        {/* Logo Cloud */}
        <div className="relative overflow-hidden py-8">
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r "></div>
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l "></div>
          
          <div className="flex space-x-12 animate-marquee whitespace-nowrap">
            {[...universities.slice(0, 12), ...universities.slice(0, 12)].map((uni, index) => (
              <div key={index} className="inline-flex flex-col items-center px-6">
                <div className="h-20 w-32 flex items-center justify-center">
                  <img
                    src={uni.image}
                    alt={uni.name || `University partner ${index}`}
                    className="max-h-full max-w-full  hover:grayscale-0 transition-all duration-300 hover:scale-110"
                  />
                </div>
                {uni.name && (
                  <p className="text-xs font-medium text-gray-500 mt-2 text-center">
                    {uni.name}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Grid View Toggle */}
        <div className="flex justify-center mt-8">
          <button 
            onClick={() => setShowAllUniversities(true)}
            className="px-6 py-3 bg-[#fa5d15] text-white rounded-md shadow-lg hover:bg-[#e04c0c] transition transform hover:scale-105"
          >
            View All Universities
          </button>
        </div>
      </div>

      

<div className="w-full max-w-5xl mx-auto mt-16">
  <div className="text-center mb-10">
    <h2 className="text-3xl font-bold text-[#fa5d15] mb-2">
      Top Corporate Partners
    </h2>
    <p className="text-gray-600">
      Working with industry leaders to bridge education and employment
    </p>
  </div>

  {/* Auto-scrolling wrapper */}
  <div className="relative overflow-hidden">
    <div className="flex w-max animate-scroll-x space-x-6">
      {[...companies, ...companies].map((comp, index) => (
        <div
          key={index}
          className="min-w-[180px] flex-shrink-0 flex flex-col items-center bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
        >
          <div className="h-24 w-24 mb-4 flex items-center justify-center">
            <img
              src={comp.image}
              alt={comp.name}
              className="max-h-full max-w-full object-contain"
            />
          </div>
          <p className="text-md font-semibold text-gray-800 text-center">
            {comp.name}
          </p>
        </div>
      ))}


      
    </div>
  </div>
  
</div>

      {/* View more card */}
     
      <a
        href="https://www.dereja.com/companies"
        target="_blank"
        rel="noopener noreferrer"
        
      >
        <div className="flex justify-center mt-8">
          <button 
            
            className="px-6 py-3 bg-[#fa5d15] text-white rounded-md shadow-lg hover:bg-[#e04c0c] transition transform hover:scale-105"
          >
            View All companies
          </button>
        </div>
        
      </a>
    
    
      
      {showAllUniversities && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white p-6 border-b flex justify-between items-center">
              <h3 className="text-2xl font-bold text-gray-800 mt-6">
                All Partner Universities
              </h3>
              <button 
                onClick={() => setShowAllUniversities(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 p-6">
              {universities.map((uni, index) => (
                <div 
                  key={index} 
                  className="flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-white hover:shadow-md transition"
                >
                  <div className="h-20 w-full mb-3 flex items-center justify-center">
                    <img
                      src={uni.image}
                      alt={uni.name || `University ${index + 1}`}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                  {uni.name && (
                    <p className="text-sm font-medium text-gray-700 text-center">
                      {uni.name}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      
      <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 10s linear infinite;
        }

        @keyframes scroll-x {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.animate-scroll-x {
  animation: scroll-x 40s linear infinite;
}

      `}
      
      
      </style>
    </div>
  );
}